import React, { useEffect, useContext } from "react"
import { Box, Grid } from "@material-ui/core"
import { PoppinsSemiBold } from "common/typographies"
import i18n from "i18n"
import AuthContext from "context/auth/authContext"
import SubscriptionContext from "context/subscription/subscriptionContext"
import * as amplitude from "@amplitude/analytics-browser"
import CompanyInfoSection from "./CompanyInfo/CompanyInfoSection"
import TrademarksSection from "./TrademarksSection"
import NumerationSection from "./NumerationSection"
import DecimalsSection from "./DecimalsSection"
import TaxesSection from "./Taxes/TaxesSection"
import IntegrationsSection from "./IntegrationsSection"
import { subscriptionHasEnabledFeature } from "utils/subscriptionEntitlements"
import { VERIFACTU } from "constants/entitlements"

const GeneralComponent = () => {
  const { user, organizationFields } = useContext(AuthContext)
  const { subscriptionState } = useContext(SubscriptionContext)
  const hasVerifactu = subscriptionHasEnabledFeature(
    subscriptionState,
    VERIFACTU,
  )

  useEffect(() => {
    amplitude.track({
      event_type: "General Profile Visited",
      event_properties: { accountEmail: user?.email },
    })
  }, [])

  return (
    <Box>
      <PoppinsSemiBold
        style={{ fontSize: "20px", marginLeft: "30px", marginBottom: "20px" }}
      >
        {i18n.t("Configuración")}
      </PoppinsSemiBold>
      <Grid
        container
        style={{
          backgroundColor: "transparent",
          height: "auto",
          paddingLeft: "20px",
          paddingRight: "20px",
          marginBottom: "50px",
        }}
        direction="row"
        spacing={1}
      >
        <Grid
          item
          xs={12}
          style={{
            paddingLeft: "12px",
            cursor: "pointer",
            width: "100%",
            position: "relative",
          }}
        >
          <Grid container direction="row" spacing={2} alignItems="stretch">
            <Grid item xs={12} md={6} sx={{ display: "flex" }}>
              <CompanyInfoSection organizationFields={organizationFields} />
            </Grid>
            <Grid item xs={12} md={6} sx={{ display: "flex" }}>
              <TrademarksSection />
            </Grid>
            <Grid item xs={12} md={6} sx={{ display: "flex" }}>
              <NumerationSection
                prefix1={organizationFields?.prefix1 || ""}
                prefix2={organizationFields?.prefix2 || ""}
                isDynamicNumberation={
                  !!organizationFields?.is_dynamic_numeration
                }
                nextNumber={organizationFields?.next_number || "1"}
              />
            </Grid>
            <Grid item xs={12} md={6} sx={{ display: "flex" }}>
              <DecimalsSection organizationFields={organizationFields} />
            </Grid>
            <Grid item xs={12} md={6} sx={{ display: "flex" }}>
              <TaxesSection organizationId={user["custom:organizationId"]} />
            </Grid>
            {hasVerifactu && (
              <Grid item xs={12} md={6} sx={{ display: "flex" }}>
                <IntegrationsSection organizationFields={organizationFields} />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )
}

export default GeneralComponent
